import { FC, useContext } from "react";
import ModalConfig from "components/Modals/ModalConfig";
import Modal from "utils/hookedComponents/Modal";
import { useHomeInstagram } from "./core/homeInstagram.hook";
import { HomeContext } from "pages/Home";
import { Marketings } from "pages/Home/core/home.types";

const HomeInstagram: FC = () => {
  const homeContext = useContext(HomeContext);
  const { isVisible, showModal, hideModal, reference } = { ...homeContext };

  useHomeInstagram({ showModal });

  return isVisible && hideModal ? (
    <Modal
      reference={reference}
      isVisible={isVisible}
      content={
        <ModalConfig marketing={Marketings.instagram} hideModal={hideModal} />
      }
    />
  ) : null;
};

export default HomeInstagram;
